import React from 'react'
import PropTypes from 'prop-types'
import { Fieldset } from 'primereact/fieldset'
import styleMemory from '../../../../../css/generals/Memory.module.css'
import { useTranslation } from 'react-i18next'

export default function DiskDrive ({ diskDrive }) {
  const { t } = useTranslation('hardware')

  return (
    <div style={{ marginTop: '1rem' }}>
        {diskDrive?.length > 0 && diskDrive?.map((item, index) => {
          return (
                <Fieldset key={index + 1} legend={`${t('title5')} ${index + 1}`} toggleable className={ styleMemory.legendHeader }>
                    <p><span className={ styleMemory.bold }>{t('label17')}</span><span>{item?.Size ? Math.floor((parseInt(item?.Size) / 1000000000)) + 'GB' : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label11')}</span><span>{item?.Description ? item?.Description : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label1')}</span><span>{item?.Manufacturer ? item?.Manufacturer : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label2')}</span><span>{item?.Name ? item?.Name : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label12')}</span><span>{item?.Model ? item?.Model : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label3')}</span><span>{item?.SerialNumber ? item?.SerialNumber : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label15')}</span><span>{item?.MediaType ? item?.MediaType : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label18')}</span><span>{item?.DeviceId ? item?.DeviceId : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label19')}</span><span>{item?.PNPDeviceId ? item?.PNPDeviceId : t('notAvailable')}</span></p>
                </Fieldset>
          )
        })}
    </div>
  )
}

DiskDrive.propTypes = {
  diskDrive: PropTypes.array
}
